import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

/**
 * Modal para errores del servidor
 */
@Component({
  standalone: false,
  selector: 'app-error-server',
  templateUrl: './error-server.component.html',
  styleUrls: ['./error-server.component.scss']
})
export class ErrorServerComponent implements OnInit {

  @Input() headerFooter: boolean;
  @Input() hideTryButton: boolean;
  /**
   * Output para emitir cuando se cierra el modal
   */
  @Output() closeError = new EventEmitter<boolean>();

  /**
 * Determines whether rapid score is
 */
  isRapidScore: boolean;

  /**
   * Crea una instancia para error server component.
   */
  constructor() { }

  ngOnInit(): void {
    this.isRapidScore = !!JSON.parse(sessionStorage.getItem('getParams'));
  }

  /**
   * Cierra el modal
   */
  close() {
    this.closeError.emit(false);
  }

}
